const KEY = "dhj_manual_session";

export const MANUAL_ROLES = ["buyer", "seller", "agent", "broker"];

export const DEMO_USERS = [
  { email: "buyer@dreamhome.local", password: "demo123", role: "buyer", name: "Demo Buyer" },
  { email: "seller@dreamhome.local", password: "demo123", role: "seller", name: "Demo Seller" },
  { email: "agent@dreamhome.local", password: "demo123", role: "agent", name: "Demo Agent" },
  { email: "broker@dreamhome.local", password: "demo123", role: "broker", name: "Demo Broker" },
  { email: "admin@dreamhome.local", password: "demo123", role: "admin", name: "Demo Admin" },
];

export function readSession() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function writeSession(session) {
  if (!session) {
    localStorage.removeItem(KEY);
    return;
  }
  localStorage.setItem(KEY, JSON.stringify(session));
}

export function authenticate({ email, password, role }) {
  const match = DEMO_USERS.find(
    (user) =>
      user.email.toLowerCase() === String(email || "").trim().toLowerCase() &&
      user.password === String(password || "") &&
      (!role || user.role === role || user.role === "admin")
  );
  if (!match) return { ok: false, error: "That sign-in did not match. Check the email and password for your role." };
  const session = {
    email: match.email,
    role: match.role,
    name: match.name,
    at: Date.now(),
  };
  writeSession(session);
  return { ok: true, session };
}

export function canReadManual(session, role) {
  if (!session) return false;
  if (session.role === "admin") return true;
  return session.role === role;
}

export function loginPath(role) {
  return role ? `/login?for=${encodeURIComponent(role)}` : "/login";
}
